import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-page__hero">
        <div className="container">
          <div className="legal-page__breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">›</span>
            <span>Privacy Policy</span>
          </div>
          <h1 className="legal-page__title">Privacy Policy</h1>
          <p className="legal-page__meta">
            TaxiOps — An Old Alex Hub Company
            <span aria-hidden="true"> · </span>
            Effective: Phase One Launch, 2025
          </p>
        </div>
      </div>

      <div className="container legal-page__body">
        <div className="legal-page__content">

          <section className="legal-section">
            <h2>Overview</h2>
            <p>
              This Privacy Policy describes how this public marketing website for TaxiOps
              (the "Site"), operated by Old Alex Hub, handles information in connection with
              your visit. TaxiOps is an official business venture of Old Alex Hub.
            </p>
            <p>
              This Site is a static public marketing website. It does not have a backend
              server, does not operate a contact form, does not collect personal information
              through the website itself, and does not require account creation or login.
            </p>
          </section>

          <section className="legal-section">
            <h2>Information We Do Not Collect</h2>
            <p>
              This website does not:
            </p>
            <ul>
              <li>Operate a contact form or any web-based data submission mechanism</li>
              <li>Collect names, email addresses, or personal information through the Site</li>
              <li>Require or request account creation</li>
              <li>Use backend analytics that collect identifiable visitor information</li>
              <li>Place tracking cookies for advertising or remarketing purposes</li>
              <li>Sell, share, or transfer visitor data to third parties</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Email Communication via Mailto Links</h2>
            <p>
              This Site contains mailto links that allow visitors to voluntarily initiate
              email communication with Old Alex Hub at <strong>info@oldalexhub.com</strong>.
            </p>
            <p>
              When you click a mailto link, your device's default email application opens
              with a pre-populated recipient address and suggested subject line. This action
              is performed entirely on your device. No data is transmitted to this website
              or any server operated by Old Alex Hub as a result of clicking a mailto link.
            </p>
            <p>
              If you choose to compose and send an email, that email is transmitted using
              your email provider's systems, not through this website. Any information you
              include in that email — including your name, email address, and message
              content — is provided voluntarily and used only to respond to your inquiry.
              Old Alex Hub does not sell or share email correspondence.
            </p>
          </section>

          <section className="legal-section">
            <h2>Standard Web Server Logs</h2>
            <p>
              Like most websites, the hosting infrastructure that serves this Site may
              automatically log standard technical information such as IP addresses, browser
              type, referring URLs, and pages accessed. This information is collected by
              the hosting provider at the infrastructure level for standard operational
              purposes and is not used by Old Alex Hub to personally identify visitors.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <p>
              This Site loads the Inter typeface from Google Fonts. When your browser
              requests fonts from Google's servers, Google may collect certain technical
              information in accordance with its own privacy policies. This is the only
              third-party resource loaded by this Site.
            </p>
            <p>
              Old Alex Hub is not responsible for the privacy practices of Google Fonts
              or any other third-party service.
            </p>
          </section>

          <section className="legal-section">
            <h2>Children's Privacy</h2>
            <p>
              This Site is not directed at children under the age of 13. TaxiOps is a
              business-to-business operations platform intended for transportation
              companies and their authorized representatives. We do not knowingly collect
              any personal information from children.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to This Policy</h2>
            <p>
              Old Alex Hub may update this Privacy Policy as the TaxiOps platform and
              business evolve. Material changes will be reflected on this page with an
              updated effective date. This policy reflects the current state of the
              public marketing website only.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact</h2>
            <p>
              Questions about this Privacy Policy may be directed to Old Alex Hub at:{' '}
              <a href="mailto:info@oldalexhub.com?subject=TaxiOps Privacy Policy Inquiry" className="legal-page__link">
                info@oldalexhub.com
              </a>
            </p>
          </section>

          <div className="legal-page__nav-links">
            <Link to="/" className="btn btn--outline">← Back to Home</Link>
            <Link to="/terms" className="btn btn--outline">View Terms →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
